import { obterRequisicoesAsync,  obterRequisicoesBaixaAsync} from "../../services/requisicaoService";

const atualizarRequisicoes = async ({ commit }) => {
    const requisicoes = await obterRequisicoesAsync();
    commit('atualizarRequisicoes', requisicoes);
}

const atualizarRequisicoesBaixa = async ({ commit }) => {
    const requisicoesBaixa = await obterRequisicoesBaixaAsync();
    commit('atualizarRequisicoesBaixa', requisicoesBaixa);
}

const atualizarRequisicao = ({ commit }, requisicao) => {
    commit('atualizarRequisicao', requisicao);
}

const addRequisicao = ({ commit }, requisicao) => {
    commit('addRequisicao', requisicao);
}

const updateRequisicao = ({ commit }, requisicao) => {
    commit('updateRequisicao', requisicao);
}

const updateRequisicaoBaixa = ({ commit }, requisicao) => {
    commit('updateRequisicaoBaixa', requisicao);
}

export default {
    atualizarRequisicoes,
	atualizarRequisicoesBaixa,
    atualizarRequisicao,
    addRequisicao,
    updateRequisicao,
    updateRequisicaoBaixa
}